import type { ComponentProps } from 'react';
import { Badge as RadixBadge } from '@radix-ui/themes';
import { cn } from '@/lib/utils';
import { RadixColors } from './RadixProps';
import type { TextProps } from './Text';

type BadgeProps = Omit<ComponentProps<typeof RadixBadge>, 'color'> & {
  color?: RadixColors | 'black';
  wrap?: TextProps['wrap'];
  italic?: boolean;
};

export function Badge({
  className,
  color,
  radius = 'full',
  variant = 'solid',
  wrap,
  italic = false,
  ...props
}: BadgeProps) {
  const isBlack = color === 'black';
  return (
    <RadixBadge
      variant={variant}
      radius={radius}
      color={isBlack ? undefined : color}
      className={cn(
        isBlack && 'badge-black',
        wrap && `badge-wrap-${wrap}`,
        italic && 'badge-italic',
        className
      )}
      {...props}
    />
  );
}

export type { BadgeProps };
